import { GET_TIPOS_MAQUINA, ADD_TIPO_MAQUINA, MODIFY_TIPO_MAQUINA, DELETE_TIPO_MAQUINA, UPDATE_TIPOS_MAQUINA } from '../constants/action_types';

const initialState = {
    tiposmaquina: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_TIPOS_MAQUINA:

            return {
                tiposmaquina: [],
                isLoading: true
            };
        case GET_TIPOS_MAQUINA + "_SUCCESS":
            return {
                tiposmaquina: action.payload.data,
                isLoading: false
            };

        case ADD_TIPO_MAQUINA:

            const newArr = [...state.tiposmaquina, action.payload]
            return {
                tiposmaquina: newArr,
                isLoading: false
            };

        case MODIFY_TIPO_MAQUINA:

            return {
                tiposmaquina: state.tiposmaquina.map((tipoZona) => {
                    if (tipoZona.id !== action.payload.id) return tipoZona;
                    else return action.payload
                }),
                isLoading: false
            };

        case DELETE_TIPO_MAQUINA:

            return {
                tiposmaquina: state.tiposmaquina.filter(tipoZona => tipoZona.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_TIPOS_MAQUINA + "_SUCCESS":

            return state;

        default:

            return state;
    }
}